module.exports = __webpack_public_path__ + "img/intro-bg.b6e96625.jpg";